import { signal } from '@preact/signals-react';

export const alertaMensagem = signal({
    open: false,
    title: 'Erro',
    message: 'Erro desconhecido',
    type: 'error',
});